<template>
<div class="meter-wrap">
    <div ref="meter" style="width:90%;height:90%;"></div>
</div>
</template>

<script>
//import {
//    meterOption
//} from "./meterOption"

export default {
    name: "meter-chart",
    props:{
        datas:Number
    },
    data() {
        return {
            option: {
                tooltip: {
                    formatter: '{a} <br/>{b} : {c}%'
                },
                series: [{
                    name: 'Pressure',
                    type: 'gauge',
                    progress: {
                        show: true
                    },
                    detail: {
                        valueAnimation: true,
                        formatter: '{value}',
                        textStyle: { color: 'white', fontSize: 12 },
                        offsetCenter: [0, '70%']
                    },
                    title: {
                        textStyle: {
                            color: "#FFFFFF"
                        }
                    },
                    axisLabel:{
                        distance:-60
                    },
                    data: [{
                        value: this.datas,
                        name: '',
                        itemStyle: {
                            color: '#1FD87F',
                        }
                    }]
                }]
            }
        }
    },
    watch:{
        datas(n,o){
            this.option.series[0].data[0].value=n;
            this.generatemeter()
        }
    },
    mounted() {
        this.generatemeter();
    },
    methods: {
        generatemeter() {
            let meter = this.$echarts.init(this.$refs.meter);
            window.onresize = meter.resize;
            meter.setOption(this.option);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/home/centerTop/meterEchart.vue